import React, {useState, useEffect} from 'react';
import tw from "twin.macro";
import {postReview, reviewList} from "service/review.service";
import {useAuthUser} from "hooks";
import {auth} from "FirebaseInit";
import { useHistory } from "react-router-dom";

const Comment = tw.form`max-w-screen-xl mx-auto px-2 mb-5 `;
const TextTwo = tw.button`px-2 py-1 bg-yellow-700 text-gray-100 text-sm md:text-lg  md:w-40 outline-none rounded-sm`;
const Input = tw.textarea`rounded-sm py-1 px-1 border mx-auto text-sm outline-none font-semibold text-gray-900  w-full`;
const Button = tw.div`flex justify-end outline-none`;
const ImageUrl = tw.img`w-10 rounded-full -mt-1`;
const UserName = tw.h2`text-sm font-normal leading-3 text-gray-900`;
const UserComment = tw.h3`text-sm font-semibold text-gray-900`;
const UserCommentList = tw.div`max-w-screen-xl flex mx-auto`;
const Flex = tw.div`ml-5 flex items-center my-2`;
const DivComment = tw.div` px-5 pt-3`;
const Text = tw.div`px-2 text-lg font-semibold text-gray-800 mb-2 mt-5`;
const TextErr = tw.div`text-xs font-semibold text-red-400`;
const Div = tw.div`m-2`;

const dummyUser = require('../images/dummy_user.png');

function UserReviewInputAndList({id}) {
  const history = useHistory()
  const [comment, setComment] = useState("");
  const [commentErr, setCommentErr] = useState('')
  const [review_list, setReview_list] = useState(null);

  const login = useAuthUser();
  const userRef = auth.currentUser;
  useEffect(() => {
    if (review_list === undefined || review_list === null) {
      reviewList(id)
        .then(result => setReview_list(result))
        .catch(e => console.error(e));
    }
  }, [id, review_list]);

  console.log(review_list, 'review_list');

  const PostComment = (e) => {
    e.preventDefault();
    if (login) {
      
      if (comment.length > 0) {
        console.log('hi');
        postReview({id, userRef, comment});
        var list = [{user_name: userRef.displayName, review: comment}, ...review_list];
        setReview_list(list);
        setComment("");
        setCommentErr("")
      } else {
        setCommentErr('write message')
      }
 
    } else {
     history.push('/login')
    }

  };
  return (
    <Div>
      <Text>Reviews</Text>
      <Comment>
        <Input
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="write something good"
        />
        {commentErr && <TextErr>{commentErr}</TextErr>}
        <Button>
          <TextTwo onClick={(e) => PostComment(e)} >Post Review</TextTwo>
        </Button>
      </Comment>
      {review_list && review_list.map(item =>
        <div key={item.id}>
          <Flex>
            <ImageUrl src={dummyUser} />
            <DivComment>
              <UserComment>{item.review}</UserComment>
              <UserName>{item.user_name}</UserName><br />
            </DivComment>
          </Flex>
        </div>)
      }
      <UserCommentList />
    </Div>
  );
}

export default UserReviewInputAndList;